<template>
  <div class="stepsContrato">
    <el-steps :active='step'>
      <el-step :title="$t('Paso 1')" :description="$t('Información General')"></el-step>
      <el-step :title="$t('Paso 2')" :description="$t('Flujos Aprobación')"></el-step>
      <el-step :title="$t('Paso 3')" :description="$t('Asignación de Revisores')"></el-step>
    </el-steps>
  </div>
</template>

<script>
export default {
  name: 'StepsContrato',
  props: [
    'step',
  ],
};
</script>
